// extracted by mini-css-extract-plugin
module.exports = {"comp":"N_comp___4uUj"};